/**
 * Created by vladislav on 15/03/2023
 */

const DebugStats = function () { 
    this.setEnabled(cleverapps.config.showFPS);

    cleverapps.gameManager.on("resume", () => cc.director.setDisplayStats(this.enabled));

    this.shownPlacements = [];

    cleverapps.eventBus.on("runPlacement", (code) => {
        if (Placements.ENTRIES[code].throttled) {
            this.shownPlacements.push({ code, time: Date.now() });
        }
    });

    this.addCustomProfiler();
};

DebugStats.prototype.addCustomProfiler = function () {
    if (connector.platform.oneOf(connector.WECHAT)) {
        return;
    }

    // panels stack bottom-up in the lower left corner: the profiler is the lowest, addPanel() puts new ones above it
    const panels = this.panels = this.createPanels(engine === "creator" ? "0px" : "90px");

    const container = this.profiler = this.createPanel();
    panels.appendChild(container);

    if (cleverapps.config.buildTime) {
        const buildTime = this.profilerBuildTime = document.createElement("div");
        buildTime.style.color = "rgb(255, 255, 255)";
        container.appendChild(buildTime);
    }

    const interstitial = this.profilerInterstitial = document.createElement("div");
    container.appendChild(interstitial);

    const throttle = this.profilerThrottle = document.createElement("div");
    throttle.style.cursor = "pointer";
    throttle.onclick = function () {
        cleverapps.toolModel.showPath("Debug/placementsThrottle");
    };
    container.appendChild(throttle);

    this.updateTimeShift();

    if (container.children.length) {
        cc.container.appendChild(panels);
    }

    this.profilerListener = cc.eventManager.addCustomListener(cc.Director.EVENT_AFTER_VISIT, this.updateProfiler.bind(this));
};

DebugStats.prototype.createPanels = function (offset) {
    const panels = document.createElement("div");
    panels.style.position = "absolute";
    panels.style.bottom = offset;
    panels.style.left = "0px";
    panels.style.display = "flex";
    panels.style.flexDirection = "column";
    panels.style.alignItems = "flex-start";

    if (window.top !== window.self) {
        panels.style.transform = `scale(${Math.min(1, window.innerHeight / 600)})`;
        panels.style.transformOrigin = "bottom left";
    }

    return panels;
};

DebugStats.prototype.createPanel = function () {
    const panel = document.createElement("div");
    panel.style.padding = "3px";
    panel.style.backgroundColor = "rgb(0, 0, 34)";
    panel.style.color = "rgb(0, 255, 255)";
    panel.style.font = "bold 12px Helvetica, Arial";
    return panel;
};

DebugStats.prototype.addPanel = function () {
    if (!this.panels) {
        return undefined;
    }

    const panel = this.createPanel();
    this.panels.insertBefore(panel, this.profiler);
    return panel;
};

DebugStats.prototype.removePanel = function (panel) {
    panel.remove();
};

DebugStats.prototype.toggle = function () {
    this.setEnabled(!this.enabled);
};

DebugStats.prototype.setEnabled = function (enabled) {
    this.enabled = enabled;

    if (this.panels) {
        this.panels.style.visibility = this.enabled ? "visible" : "hidden";
    }
    cc.director.setDisplayStats(this.enabled);
};

DebugStats.prototype.updateProfiler = function () {
    if (this.profilerBuildTime) {
        const passed = DateShift.realDate() - DateShift.realDate(cleverapps.config.buildTime);

        this.profilerBuildTime.innerText = DebugStats.formatDate(passed, true);
        this.profilerBuildTime.style.color = passed > cleverapps.parseInterval(DebugStats.OLD_BUILD_INTERVAL)
            ? "rgb(255, 80, 80)" : "rgb(255, 255, 255)";
    }

    this.updateInterstitial();

    this.updateThrottle();

    this.updateTimeShift();
};

DebugStats.prototype.updateInterstitial = function () {
    if (!this.profilerInterstitial) {
        return;
    }

    if (!cleverapps.adsLimits) {
        this.profilerInterstitial.innerText = "";
        return;
    }

    // runs every frame - the readout has second resolution and _getLimit re-classifies
    // the payments history on each call, so recompute a few times per second at most
    if (this.interstitialUpdateTime && DateShift.realDate() - this.interstitialUpdateTime < DebugStats.INTERSTITIAL_UPDATE_INTERVAL) {
        return;
    }
    this.interstitialUpdateTime = DateShift.realDate();

    const state = cleverapps.adsLimits.state(AdsLimits.TYPES.INTERSTITIAL);
    const leftTime = cleverapps.adsLimits.getLimitLeftTime(AdsLimits.TYPES.INTERSTITIAL);

    let value = DebugStats.formatLeftTime(leftTime);
    if (state === AdsLimits.STATE_DISABLED) {
        value = "off";
    } else if (!leftTime) {
        value = "ready";
    }

    this.profilerInterstitial.innerText = `inter ${value}`;
};

DebugStats.prototype.updateThrottle = function () {
    if (!this.profilerThrottle) {
        return;
    }

    if (!cleverapps.placements) {
        this.profilerThrottle.innerText = "";
        return;
    }

    if (this.throttleUpdateTime && DateShift.realDate() - this.throttleUpdateTime < DebugStats.INTERSTITIAL_UPDATE_INTERVAL) {
        return;
    }
    this.throttleUpdateTime = DateShift.realDate();

    const state = cleverapps.placements.getThrottleState();

    let text = "";
    if (!cleverapps.placements.isThrottleEnabled()) {
        text = "throttle off";
    } else if (state.held.length) {
        if (this.heldFor !== state.held) {
            this.heldFor = state.held;
            this.heldNext = state.held.map(DebugStats.placementLabel).find(Boolean);
        }

        text = `wait ${DebugStats.formatLeftTime(state.leftTime)}${this.heldNext ? ` ${this.heldNext}` : ""}`;
    }

    this.profilerThrottle.innerText = text;
};

// which window a held placement would open: the mission or the offer behind the manager entries, the code for the rest
DebugStats.HELD_WINDOWS = {
    missionManagerProcess: () => {
        const manager = cleverapps.missionManager;
        const type = manager.next !== undefined ? manager.next : manager.canCreateTypes().missions[0];
        return type !== undefined && (Missions[type].name || Missions[type].id);
    },

    missionStartWindow: () => {
        const mission = cleverapps.missionManager.pendingStartWindow();
        return mission && mission.name;
    },

    offerManagerProcess: () => {
        const offer = cleverapps.offerManager.findOfferWithPendingWindow();
        return offer && Offers[offer.type].name;
    }
};

DebugStats.placementLabel = function (code) {
    const resolve = DebugStats.HELD_WINDOWS[code];
    return resolve ? resolve() : code;
};

DebugStats.INTERSTITIAL_UPDATE_INTERVAL = 250;

DebugStats.OLD_BUILD_INTERVAL = "20 minutes";

DebugStats.formatLeftTime = function (leftTime) {
    const total = Math.ceil(leftTime / 1000);
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;

    return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

DebugStats.prototype.updateTimeShift = function () {
    if (DateShift.getDelta()) {
        if (!this.profilerTimeShift) {
            this.profilerTimeShift = document.createElement("div");
            this.profiler.appendChild(this.profilerTimeShift);
        }

        this.profilerTimeShift.innerText = DebugStats.formatDate(new Date());
    } else if (this.profilerTimeShift) {
        this.profilerTimeShift.remove();
        this.profilerTimeShift = undefined;
    }
};

DebugStats.formatDate = function (date, diffOnly) {
    date = DateShift.realDate(date);

    if (diffOnly) {
        return date.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
            timeZone: "UTC"
        });
    }

    return date.toLocaleString("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    });
};

if (engine === "creator") {
    cc.profiler.generateCanvas = cleverapps.extendFunc(cc.profiler.generateCanvas, function (...args) {
        this._super.call(this, ...args);

        cc.profiler._ctx.fillStyle = "black";
        cc.profiler._ctx.fillRect(0, 0, 500, 500);
        cc.profiler._ctx.fillStyle = "#00EFFF";
    });
}
